// /reconciliation URL search-state. Mirrors the transactions-page Period
// shape (issue #105) so deep links share one ISO/period vocabulary across
// the app and consumers reuse the same `Period` type.

import {
  type InvalidPeriod,
  type Period,
  parseLinkPeriod,
  type SearchParams,
  serializeLinkPeriod,
} from './schemas.ts';

export interface ReconciliationSearch {
  readonly period: Period;
  /** Set when the link's period could not be read; see LinkPeriod. */
  readonly invalidPeriod: InvalidPeriod | null;
}

export function parseReconciliationSearch(params: SearchParams): ReconciliationSearch {
  const { period, invalidPeriod } = parseLinkPeriod(params);
  if (period.kind === 'range' && period.to < period.from) {
    return { period: { kind: 'range', from: period.to, to: period.from }, invalidPeriod };
  }
  return { period, invalidPeriod };
}

export function serializeReconciliationSearch(value: ReconciliationSearch): SearchParams {
  return { ...serializeLinkPeriod(value) };
}
